<template>
  <div class="menu_container">
    <div class="menu">
      <div class="menu_item" @click="vCloseSidebar(itemMenu)" v-for="(itemMenu, index) in aListMenu" :key="index">
        <div  v-if="bAccessItem(itemMenu)">
          
          <div v-if="itemMenu.children !== undefined">

            <span @click="vOpenSubMenu(itemMenu)">{{itemMenu.meta.title}}</span>

            <transition name="slidebottom">
              <div class="submenu" v-show="itemMenu.meta.isOpen">
                <div v-for="(children, index) in itemMenu.children" :key="index" class="submenu-link menu-item">
                  <a @click="vGoTo(sFormatQuery(children.meta.TMOTCLE), itemMenu)" v-if="children.meta.TMOTCLE">{{ children.meta.TMOTCLE  }}</a> 
                  <a @click="vClickMenu(itemMenu, children)" v-else>{{ children.meta.title  }}</a>
                </div>
                <div class="btn-voir-tout" v-show="bCollection">
                  <a class="view-all" @click="vResetRecherche(itemMenu)">{{$_('view_all')}}</a>
                </div>
                <div class="close-sidebar">
                  <span @click="vCloseSidebar(itemMenu.meta)"><i class="material-icons">arrow_back</i></span>
                </div>
              </div>
            </transition>

          </div>
          <div v-else>
            <router-link :to="{ name: itemMenu.name }">{{$_(itemMenu.meta.lang_code)}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchService from "@/modules/recherche/services/searchService";

import { Bus } from '@/common/Bus.js';

export default {
  data() {
    return {
      aListMenu: [],
      bCollection: false,
    };
  },
  methods: {
    bAccessItem(itemMenu) {

      if( (itemMenu.meta.customer_required !== undefined && itemMenu.meta.customer_required === true) &&
        Object.keys(this.$store.getters['application/get_application_customer']).length === 0
      ) {
        return false
      }
      
      if(JSON.parse(localStorage.getItem('satabapp-company')) === null) {
        return false;
      }

      let role = JSON.parse(localStorage.getItem('satabapp-company')).PTUSER;

      if(itemMenu.meta.role !== undefined) {
        return itemMenu.meta.role.includes(role);         
      } else {
        return false
      }
    },
    vResetRecherche(itemMenu) {

      searchService.getResearch('').then(res => {
        this.$router
          .push({
            name: 'searchresult',
            params: { product: res.data.DS_O.OUT },
            query: { menu: 'all' }
          });

           itemMenu.meta.isOpen = false;
           Bus.$emit('overlay', false)
  
      }).catch(err => {});
    },
    vCloseSidebar(test) {
      test.isOpen = false;
      if(test.children === undefined) {

        Bus.$emit("openSidebar");
        Bus.$emit("overlay");
      }
    },
    vCloseSubMenu() {
    
      Bus.$emit("openSidebar");
      Bus.$emit("overlay");
    },

    /**
     * [vGetRouteMenu description]
     *
     * @return  {[type]}  [return description]
     */
    vGetRouteMenu() {
      this.$router.options.routes.forEach(route => {
        if (route.meta.menu === true) {
          route.meta.isOpen = false;
          this.aListMenu.push(route)
        }
      });

      
      this.aListMenu.sort((a, b) => (a.meta.order - b.meta.order))

    },
    /**
     * [vOpenSubMenu description]
     *
     * @param   {[type]}  itemMenu  [itemMenu description]
     *
     * @return  {[type]}            [return description]
     */
    vOpenSubMenu(itemMenu) {

      if(itemMenu.meta.collection === undefined || itemMenu.meta.collection === false) {
        this.bCollection = false;
      } else {
        this.bCollection = true;
      }

      // Si ue fonction doit être executée à l'ouverture du menu
      if(itemMenu.meta.fn !== undefined && itemMenu.meta.fn !== '') {

        let data = this[itemMenu.meta.fn]()

        data.then(res => {

          itemMenu.children = Array();

          Object.values(res).map(object => {
            itemMenu.children.push({meta: {TMOTCLE: object.TMOTCLE}});
          })
        })
      }

      this.aListMenu.map(item => {
        if(item.name != itemMenu.name) {
          item.meta.isOpen = false;
        }
      })

      itemMenu.meta.isOpen = !itemMenu.meta.isOpen
      
      Bus.$emit('overlay', itemMenu.meta.isOpen);
      Bus.$on('sidemenuclose', () => {
        itemMenu.meta.isOpen = false;
      })
    },

    vClickMenu(itemMenu, children) {
    
      this.aListMenu.map(item => {
        if(item.name != itemMenu.name) {
          item.meta.isOpen = false;
        }
      })
    
      this.$router.push({name: children.name})

      itemMenu.meta.isOpen = !itemMenu.meta.isOpen

      Bus.$emit('overlay', false);
    },
    /**
     * Affiches les collections
     *
     * @return  {Promise} 
     */
    aGetCategory() {
      return searchService.getCategory().then(res => {
        return res.data.DS_O.OUT;
      })
    },
    /**
     * [vGoTo description]
     *
     * @param   {[type]}  oParam  [oParam description]
     *
     * @return  {[type]}          [return description]
     */
    vGoTo(oParam, itemMenu) {
  
      this.$store.dispatch('recherche/SELECT', {key: 'fmotc_cat_preselected', value: oParam.fmotc_cat});
      this.$store.dispatch('recherche/SELECT', {key: 'fmotc_cat', value: oParam.fmotc_cat});

      if(this.$route.name !== 'searchresult') {
        this.$router.push({name: 'searchresult'});
      }

      this.$store.dispatch('recherche/SELECT', {key: 'launch_research', value: true});
      this.$store.dispatch('recherche/SELECT', {key: 'reset_product_list', value: true});
      this.$store.dispatch('recherche/RESET_FOR_COLLECTION');
      this.$store.dispatch('recherche/SET', {key: 'remove_tag_filter', value: true});

      itemMenu.meta.isOpen = false;
      
      Bus.$emit('overlay', itemMenu.meta.isOpen);
      Bus.$emit("openSidebar");
      Bus.$emit('resetforcollection');
    },
    /**
     * [sFormatQuery description]
     *
     * @param   {[type]}  sItemSubMenu  [sItemSubMenu description]
     *
     * @return  {[type]}                [return description]
     */
    sFormatQuery(sItemSubMenu) {
      let nCountref = 40;
      let sSelection = sItemSubMenu;
      let critere = {
              fmotc_cat: '',
      }
      if (nCountref !== undefined) {
        let nWordLength = sSelection.length;
        let nCount = nCountref - nWordLength;

        critere.fmotc_cat += sSelection + ' '.repeat(nCount);
      } else {
        critere.fmotc_cat += sSelection + '#';
      }
      return critere;
    },
  },
  created() {
    this.vGetRouteMenu();
    this.aGetCategory();
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.menu {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.menu_item {
  width: 100%;
  justify-content: center;
  display: flex;
}
.menu_item > div {
  border-bottom: solid 1px #e9e9e9;
}
.menu_item:hover {
  background-color: #f5f5f5;
}
.menu_item > div {
  position: relative;
  width: 100%;
}
.menu_item span {
  color: #8B8B8B;
  font-size: var(--fz-md);
  text-align: center;
  display: block;
  padding: 15px 0px;
}
.menu_item span:hover {
  cursor: pointer;
}
.submenu {
  position: fixed;
  top: 76px;
  left: calc(100% / 2 - 525px);
  height: calc(100vh - 75px);
  background-color: #FAFAFA;
  z-index: 100;
  width: 500px;
  display: flex;
  flex-wrap: wrap;
  padding: 40px;
  overflow: scroll;
  align-content: flex-start;
}
.submenu .submenu-link {
  width: 50%;
  text-align: center;
  margin: 10px 0px;
  height: auto;
}
.submenu-link {
  cursor: pointer;
}
.menu_item a {
  display: block; 
  padding: 15px 0;
  text-align: center;
}
.submenu a {
  padding: 0px;
}
.slidebottom-enter-active, .slidebottom-leave-active {
  transition: all .3s; 
}
.slidebottom-enter, .slidebottom-leave-to {
  opacity: 0;
  transform: translateX(calc(100% / 2 - 521px));
}
.menu_container {
  margin-bottom: 15px;
}
.btn-voir-tout {
    width: 100%;
    border-top: solid gray 1px;
    padding-top: 15px;
    margin-top: 5px;
    cursor: pointer;
}
.close-sidebar {
    padding: 15px 25px;
    display: none;
    justify-content: flex-end;
}
.view-all {
  font-size: 1rem;
  font-weight: bold;
}

@media (max-width: 800px) {
  .submenu {
    left: 0 !important;
    width: 100%;
    top: 0px !important;
    height: calc(100vh - 60px);
    padding: 40px 30px 20px !important;
  }
  .submenu .submenu-link {
    width: 100%;
  }
  .close-sidebar {
    display: flex;
    width: 100%;
    padding: 0px 20px;
    margin-top: 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    border-top: solid 2px #F00B35;
  }
  .close-sidebar i {
    color: #000;
  }
  .submenu {
    padding: 40px 30px 80px;
  }
  .menu_item:empty {
    border: none;
  }
}
@media (max-width: 1370px) {
  .submenu {
    top: 75px;
    left: 279px;
  }
}

</style>